import { CircularProgress, useTheme } from "@mui/joy";
import { Box, CssBaseline, Grid, useMediaQuery } from "@mui/material";
import { useSignOutMutation } from "@nerdjs/account-kit";
import { initNetworkAction } from "@nerdjs/nerd-network";
import { clearNotification, NerdNotifier } from "@nerdjs/nerd-ui";
import { Purchases } from "@revenuecat/purchases-js";
import { ReactElement, useEffect } from "react";
import { AppRouter } from "../../appRouter";
import { AppConfig } from "../../environement";
import { useCurrentUser } from "../../redux/user/userHook";
import { RouterConfig } from "../config/routerConfig";
import { useAppDispatch, useAppSelector } from "../hooks";
import { MainAppBar } from "../mainAppBar/mainAppBar";
import { MainMenu } from "../mainMenu/mainMenu";
import { OpaReady } from "../opaReady/opaReady";
import { useSelector } from "react-redux";
import { endpointSelector } from "../../reducers/rhapsody";

/**
 * App wrapper
 *
 * @returns {ReactElement} App wrapper
 */
export default function NerdApp(): ReactElement {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.down("md"), {
    noSsr: true,
  });
  const { isSuccess } = useSignOutMutation()[1];
  const endpoint = useSelector(endpointSelector);

  useEffect(() => {
    dispatch(initNetworkAction(AppConfig.api));
  }, []);

  const { isError, data, error } = useCurrentUser();

  useEffect(() => {
    if (data?.uuid) {
      Purchases.configure(AppConfig.apiKeys.revenueCat, data.email);
    }
  }, [data]);

  useEffect(() => {
    //If signout success, refresh window to reset redux state
    if (isSuccess) {
      window.location.replace(RouterConfig.root);
    } else if (error) {
      console.log(error);
      debugger;
    }
  }, [isSuccess, isError]);

  if (!endpoint) return <Box />;
  return (
    <NotifierWrapper>
      <OpaReady>
        <Box
          sx={{
            // backgroundImage: `url("${AppConfig.app.rootBackground}") `,
            backgroundSize: "cover",
            display: "flex",
            flex: 1,
            flexDirection: md ? "column" : "row",
          }}
        >
          <CssBaseline />
          <MainAppBar />
          <MainMenu />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              display: "flex",
            }}
          >
            <AppRouter />
          </Box>
        </Box>
      </OpaReady>
    </NotifierWrapper>
  );
}

const NotifierWrapper = ({ children }: { children: ReactElement }) => {
  const dispatch = useAppDispatch();
  const notification = useAppSelector((s) => s.notification);
  return (
    notification && (
      <NerdNotifier
        {...notification}
        onClose={() => {
          dispatch(clearNotification());
          notification.onClose?.();
        }}
      >
        {children}
      </NerdNotifier>
    )
  );
};
